import { SidebarTrigger } from '@/components/ui/sidebar';
import { DatePicker } from './ui/date-picker';

export function SiteHeader() {
  return (
    <header className="flex h-(--header-height) shrink-0 items-center gap-2 border-white/[0.06] border-b transition-[width,height] ease-out group-has-data-[collapsible=icon]/sidebar-wrapper:h-(--header-height)">
      <div className="flex w-full items-center justify-between gap-1 px-4 lg:gap-2 lg:px-6">
        <SidebarTrigger className="-ml-1 text-white/40 hover:bg-white/[0.04] hover:text-white/80" />
        <DatePicker />
      </div>
    </header>
  );
}
